import React from "react";
import { Helmet } from "react-helmet-async";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import WebsiteLayout from "layouts/WebsiteLayout";

import { routes } from "routes/routes";

const TermsOfService: React.FC = () => {
  const appLink = (
    <Link target="_blank" underline="none" href="https://ibanoplata.com/">
      https://ibanoplata.com/
    </Link>
  );

  return (
    <WebsiteLayout>
      <Helmet>
        <link
          rel="canonical"
          href={`${window.location.origin}${routes.termsOfService}`}
        />
      </Helmet>
      <Typography variant="h2" mt={4} mb={2}>
        УМОВИ КОНФІДЕНЦІЙНОСТІ
      </Typography>
      <Typography mb={1}>
        Правовласник гарантує, що сервіс на веб-сайті {appLink}
        забезпечує дотримання принципу конфіденційності щодо інформації про
        Користувачів.
      </Typography>
      <Typography mb={1}>
        Для надання повного та якісного обсягу послуг при використанні сервісу
        на веб-сайті {appLink} Правовласник може отримати від Користувача
        наступну інформацію:
      </Typography>
      <Box component="ul" ml={3} mb={1}>
        <Box component="li">
          <Typography>
            прізвище, ім`я, по батькові (за наявності) фізичної особи, адреса
            електронної пошти, номер телефону;
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            платіжна інформація Користувача – IBAN, реєстраційний номер
            облікової карти платника податків (використовується для генерації
            платіжного посилання ми також зберігаємо платіжну інформацію
            користувача в базі даних (ІБАН, податковий номер)
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            інша додаткова інформація (зокрема, дані облікового запису
            Користувача в GOOGLE, META тощо), необхідна для використання
            Користувачем сервісу на веб-сайті {appLink}.
          </Typography>
        </Box>
      </Box>
      <Typography mb={1}>
        З метою користування розширеними функціями веб-сайту
        {appLink} Користувач може надавати Правовласнику доступ до свого
        банківського акаунту через токен, який генерується Користувачем в
        персональному кабінеті на сайті банку Користувача (Монобанк, Приватбанк
        тощо).
      </Typography>
      <Typography mb={1}>
        У процесі користування сервісом на веб-сайті {appLink}
        здійснюється автоматичне збирання наступної інформації:
      </Typography>
      <Box component="ul" ml={3} mb={1}>
        <Box component="li">
          <Typography>технічна інформація про пристрій Користувача;</Typography>
        </Box>
        <Box component="li">
          <Typography>
            дані користувача, які користувач самостійно вніс у сервіс на
            веб-сайті {appLink};
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            статистика використання сервісу та інші дані, до яких користувач
            дозволив доступ сервісу (геолокація і т д);
          </Typography>
        </Box>
        <Box component="li">
          <Typography>
            дані про відвідувачів (публічні дані про їх акаунти) сервісу на
            веб-сайті {appLink}.
          </Typography>
        </Box>
      </Box>
      <Typography mb={1}>
        Сервіс на веб-сайті {appLink} може збирати і іншу інформацію Користувача
        та про Користувача відповідно до Публічної оферти (Умов користування),
        на яку погодився Користувач, використовуючи Сервіс.
      </Typography>
      <Typography mb={1}>
        Правовласник використовує особисту інформацію Користувачів для:
      </Typography>
      <Box component="ul" ml={3} mb={1}>
        <Box component="li">
          <Typography>вдосконалення роботи сервісу;</Typography>
        </Box>
        <Box component="li">
          <Typography>
            виявлення та запобігання шахрайству, спаму, зловживанням, інцидентам
            безпеки та іншій шкідливій діяльності під час використання сервісу;
          </Typography>
        </Box>
      </Box>
      <Typography mb={1}>
        Користувач несе відповідальність за правильність введення особистої
        інформації.
      </Typography>
      <Typography mb={1}>
        Використовуючи сервіс на веб-сайті {appLink}, Користувач надає згоду на
        доступ, обробку, зберігання, поширення та використання персональних
        даних (інформації) про себе, які він/вона надає Правовласнику під час
        користування сервісом.
      </Typography>
      <Typography mb={1}>
        Персональні дані Користувачів обробляються виключно в рамках вимог
        Закону України «Про захист персональних даних», а також Регламентом
        GDPR. Доступ третім особам до персональних даних надається
        Правовласником лише у випадках, прямо передбачених чинним законодавством
        України, зокрема, на вимогу правоохоронних органів або суду.
      </Typography>
      <Typography mb={1}>
        Вся інформація від Користувачів, яка збирається Правовласником, захищена
        технічними засобами і процедурами забезпечення безпеки з метою
        запобігання несанкціонованому доступу або використання даних.
      </Typography>
      <Typography mb={1}>
        Вся зібрана сервісом інформація від користувачів може охоронятися як
        комерційна таємниця в порядку, визначеному законом.
      </Typography>
      <Typography mb={5}>
        Інші відносини між Користувачем та Правовласником врегульовані Публічною
        офертою (Правилами користування сервісом на веб-сайті
        {appLink}), яка міститься на веб-сайті
        {appLink}. Всі поняття, які вживаються в Умовах конфіденційності, та
        умови використання сервісу на веб-сайті
        {appLink}, вказані в умовах Публічної оферти.
      </Typography>
    </WebsiteLayout>
  );
};

export default TermsOfService;
